<template>
  <div class="w" style="position: relative" :class="{ fullscreen: isRouteFullscreen }">
    <div style="height: 30px; position: absolute; z-index: 1; left: 0; right: 0; transform: translateY(20px);" v-if="isRouteFullscreen">
      <div class="svgs" style="float: right;">
        <svg @click="$router.push('/fullscreen/bigData')" style="margin-right: -20px;" t="1751610347433" viewBox="0 0 1027 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1749" width="60" height="30"><path d="M598.361605 38.378364v198.288215H962.956065c38.378364 0 63.96394 25.585576 63.96394 63.963941v422.162006c0 38.378364-25.585576 63.96394-63.96394 63.96394H598.361605v198.288215c0 6.396394-6.396394 19.189182-12.792788 25.585576-12.792788 12.792788-38.378364 19.189182-51.171152 6.396394l-511.711523-454.143976-6.396394-6.396394c-25.585576-25.585576-19.189182-63.96394 6.396394-89.549517l511.711523-454.143976c12.792788-6.396394 19.189182-12.792788 25.585576-12.792788 25.585576 0 38.378364 19.189182 38.378364 38.378364z" p-id="1750"></path></svg>
        <svg @click="$router.push('/fullscreen/service')" t="1751608233199" viewBox="0 0 1027 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1468" width="60" height="30"><path d="M466.052637 0c6.384283 0 12.768565 6.384283 25.53713 12.768565l510.742616 453.284072c25.537131 25.537131 31.921413 63.842827 6.384283 89.379957l-6.384283 6.384283-510.742616 453.284071c-12.768565 12.768565-38.305696 12.768565-51.074261-6.384282-6.384283-6.384283-12.768565-19.152848-12.768565-25.537131v-197.912764H63.842827c-38.305696 0-63.842827-25.537131-63.842827-63.842827V300.061287c0-38.305696 25.537131-63.842827 63.842827-63.842827h363.904114V38.305696c0-19.152848 12.768565-38.305696 38.305696-38.305696z" p-id="1469"></path></svg>
      </div>
    </div>
    <div class="container" ref="container">
      <div id="map" ref="mapChart" />
      <div class="header">
        <div class="header-inner">
          <template v-if="lang === 'en'">
            <dv-decoration-10 style="width: 29%; height: 5px"/>
            <dv-decoration-8 :color="['#54c0f9', 'transparent']" style="width: 12%; height: .4167rem"/>
            <div style="width: 18%" class="title_wrapper">
              <h1 class="title" style="text-wrap: nowrap;">Deman Data Monitor</h1>
              <dv-decoration-6 style="width: 100%; height: 7px; margin-top: .2083rem"/>
            </div>
            <dv-decoration-8 :reverse="true" :color="['#54c0f9', 'transparent']" style="width: 12%; height: .4167rem"/>
            <dv-decoration-10 style="width: 29%; height: 5px; transform: rotate(180deg)"/>
          </template>
          <template v-else>
            <dv-decoration-10 style="width: 30%; height: 5px"/>
            <dv-decoration-8 :color="['#54c0f9', 'transparent']" style="width: 12%; height: .4167rem"/>
            <div style="width: 16%" class="title_wrapper">
              <h1 class="title" style="text-wrap: nowrap">德曼大数据监测中心</h1>
              <dv-decoration-6 style="width: 100%; height: 7px; margin-top: .2083rem"/>
            </div>
            <dv-decoration-8 :reverse="true" :color="['#54c0f9', 'transparent']" style="width: 12%; height: .4167rem"/>
            <dv-decoration-10 style="width: 30%; height: 5px; transform: rotate(180deg)"/>
          </template> 
        </div>
      </div>
      <div class="toggleNav">
        <div
          class="item"
          v-for="dataType in dataTypeList"
          :key="dataType.id"
          @click="changeDataType('0', dataType.id)"
        >
          <div>{{ $t(`overview.monitorContent.${dataType.n}`) }}</div>
          <div>{{ dataType.value }}</div>
        </div>
      </div>
      <div class="col" style="left: 1%;">
        <dv-border-box-12 style="height: 30%">
          <div class="chart-inner-bg">
            <div style="position: absolute; top: 0; left: 0;">
              <svg
                class="svg-inline--fa fa-chart-pie icon"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="chart-pie"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path
                  class
                  fill="currentColor"
                  d="M304 16.58C304 7.555 310.1 0 320 0C443.7 0 544 100.3 544 224C544 233 536.4 240 527.4 240H304V16.58zM32 272C32 150.7 122.1 50.34 238.1 34.25C248.2 32.99 256 40.36 256 49.61V288L412.5 444.5C419.2 451.2 418.7 462.2 411 467.7C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zM558.4 288C567.6 288 575 295.8 573.8 305C566.1 360.9 539.1 410.6 499.9 447.3C493.9 452.1 484.5 452.5 478.7 446.7L320 288H558.4z"
                />
              </svg>
              <span class="title">{{ $t('overview.monitorContent.status') }}</span>
            </div>
            <div class="statusChart" style="width: 100%; height: 100%;" />
          </div>
        </dv-border-box-12>
        <dv-border-box-12 style="height: 20%">
          <div class="chart-inner-bg">
            <div style="position: absolute; top: 0; left: 0;">
              <svg
                class="svg-inline--fa fa-chart-pie icon"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="chart-pie"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
              >
                <path
                  class
                  fill="currentColor"
                  d="M304 16.58C304 7.555 310.1 0 320 0C443.7 0 544 100.3 544 224C544 233 536.4 240 527.4 240H304V16.58zM32 272C32 150.7 122.1 50.34 238.1 34.25C248.2 32.99 256 40.36 256 49.61V288L412.5 444.5C419.2 451.2 418.7 462.2 411 467.7C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zM558.4 288C567.6 288 575 295.8 573.8 305C566.1 360.9 539.1 410.6 499.9 447.3C493.9 452.1 484.5 452.5 478.7 446.7L320 288H558.4z"
                />
              </svg>
              <span class="title">{{ $t('overview.monitorContent.Analysis') }}</span>
            </div>
            <div class="flex" style="height: 100%">
              <div style="width: 33%; height: 60%; margin-top: 8%">
                <div ref="chart1" style="width: 100%; height: 100%"></div>
                <p class="analysis">{{ $t('overview.monitorContent.open') }}{{ open }}<span v-show="lang === 'zh'">台</span></p>
              </div>
              <div style="width: 33%; height: 60%; margin-top: 8%">
                <div ref="chart2" style="width: 100%; height: 100%"></div>
                <p class="analysis">{{ $t('overview.monitorContent.loadRate') }}</p>
              </div>
              <div style="width: 33%; height: 60%; margin-top: 8%">
                <div ref="chart3" style="width: 100%; height: 100%"></div>
                <p class="analysis">{{ $t('overview.monitorContent.temp') }}</p>
              </div>
              <!-- <div style="width: 33%; height: 60%; margin-top: 8%">
                <div
                  ref="chart2"
                  style="width: 100%; height: 100%"
                ></div>
                <br/>
                <p class="analysis">平均负载率</p>
              </div>
              <div style="width: 33%; height: 60%; margin-top: 8%">
                <div
                  ref="chart3"
                  style="width: 100%; height: 100%"
                ></div>
                <br/>
                <p class="analysis">平均温度</p>
              </div>-->
            </div>
          </div>
        </dv-border-box-12>
        <dv-border-box-12 style="height: 50%">
          <div class="chart-inner-bg">
            <div style="position: absolute; top: 0; left: 0;">
              <svg
                class="svg-inline--fa fa-map icon"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="map"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 576 512"
                data-v-1bfe07b4
              >
                <path
                  class
                  fill="currentColor"
                  d="M384 476.1L192 421.2V35.93L384 90.79V476.1zM416 88.37L543.1 37.53C558.9 31.23 576 42.84 576 59.82V394.6C576 404.4 570 413.2 560.9 416.9L416 474.8V88.37zM15.09 95.13L160 37.17V423.6L32.91 474.5C17.15 480.8 0 469.2 0 452.2V117.4C0 107.6 5.975 98.78 15.09 95.13V95.13z"
                />
              </svg>
              <span class="title">{{ $t('overview.monitorContent.Distribution') }}</span>
            </div>
            <div style="width: 100%; height: 100%; padding-top: .3125rem;" class="capsule_wrapper">
              <dv-capsule-chart
                :config="config"
                style="width: 95%; height: 110%; padding-right: 3%"
              />
            </div>
          </div>
        </dv-border-box-12>
      </div>
      <div class="col" style="right: 1%;">
        <dv-border-box-12 style="height: 25%">
          <div class="chart-inner-bg flex">
            <div style="position: absolute; top: 0; left: 0;">
              <svg
                class="svg-inline--fa fa-database icon"
                style="top: 5%"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="database"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                data-v-089cdc57
              >
                <path
                  class
                  fill="currentColor"
                  d="M448 80V128C448 172.2 347.7 208 224 208C100.3 208 0 172.2 0 128V80C0 35.82 100.3 0 224 0C347.7 0 448 35.82 448 80zM393.2 214.7C413.1 207.3 433.1 197.8 448 186.1V288C448 332.2 347.7 368 224 368C100.3 368 0 332.2 0 288V186.1C14.93 197.8 34.02 207.3 54.85 214.7C99.66 230.7 159.5 240 224 240C288.5 240 348.3 230.7 393.2 214.7V214.7zM54.85 374.7C99.66 390.7 159.5 400 224 400C288.5 400 348.3 390.7 393.2 374.7C413.1 367.3 433.1 357.8 448 346.1V432C448 476.2 347.7 512 224 512C100.3 512 0 476.2 0 432V346.1C14.93 357.8 34.02 367.3 54.85 374.7z"
                />
              </svg>
              <span class="title">{{ $t('overview.monitorContent.emission') }}</span>
            </div>
            <div class="flex_column">
              <div class="icon-kwh" />
              <h2 class="data">{{ totalList.emissionReduction.electricityConsumption }}</h2>
              <h3 class="description">{{ $t('overview.monitorContent.electricityConsumption') }}（kW·h）</h3>
            </div>
            <div class="flex_column">
              <div class="icon-kwc" />
              <h2 class="data">{{ totalList.emissionReduction.co2EmissionReduction }}</h2>
              <h3 class="description">{{ $t('overview.monitorContent.CO2') }}（t）</h3>
            </div>
          </div>
        </dv-border-box-12>
        <dv-border-box-12 style="height: 25%">
          <div class="chart-inner-bg">
            <div style="position: absolute; top: 0; left: 0;">
              <svg
                class="svg-inline--fa fa-database icon"
                style="top: 5%"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="database"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                data-v-089cdc57
              >
                <path
                  class
                  fill="currentColor"
                  d="M448 80V128C448 172.2 347.7 208 224 208C100.3 208 0 172.2 0 128V80C0 35.82 100.3 0 224 0C347.7 0 448 35.82 448 80zM393.2 214.7C413.1 207.3 433.1 197.8 448 186.1V288C448 332.2 347.7 368 224 368C100.3 368 0 332.2 0 288V186.1C14.93 197.8 34.02 207.3 54.85 214.7C99.66 230.7 159.5 240 224 240C288.5 240 348.3 230.7 393.2 214.7V214.7zM54.85 374.7C99.66 390.7 159.5 400 224 400C288.5 400 348.3 390.7 393.2 374.7C413.1 367.3 433.1 357.8 448 346.1V432C448 476.2 347.7 512 224 512C100.3 512 0 476.2 0 432V346.1C14.93 357.8 34.02 367.3 54.85 374.7z"
                />
              </svg>
              <span class="title">{{ $t('overview.monitorContent.trend') }}</span>
            </div>
            <div class="trendChart" style="width: 100%; height: 100%"></div>
          </div>
        </dv-border-box-12>
        <dv-border-box-12 style="height: 25%">
          <div class="chart-inner-bg">
            <div style="position: absolute; top: 0; left: 0;">
              <svg
                class="svg-inline--fa fa-database icon"
                style="top: 5%"
                aria-hidden="true"
                focusable="false"
                data-prefix="fas"
                data-icon="database"
                role="img"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 448 512"
                data-v-089cdc57
              >
                <path
                  class
                  fill="currentColor"
                  d="M448 80V128C448 172.2 347.7 208 224 208C100.3 208 0 172.2 0 128V80C0 35.82 100.3 0 224 0C347.7 0 448 35.82 448 80zM393.2 214.7C413.1 207.3 433.1 197.8 448 186.1V288C448 332.2 347.7 368 224 368C100.3 368 0 332.2 0 288V186.1C14.93 197.8 34.02 207.3 54.85 214.7C99.66 230.7 159.5 240 224 240C288.5 240 348.3 230.7 393.2 214.7V214.7zM54.85 374.7C99.66 390.7 159.5 400 224 400C288.5 400 348.3 390.7 393.2 374.7C413.1 367.3 433.1 357.8 448 346.1V432C448 476.2 347.7 512 224 512C100.3 512 0 476.2 0 432V346.1C14.93 357.8 34.02 367.3 54.85 374.7z"
                />
              </svg>
              <span class="title">{{ $t('overview.monitorContent.year') }}</span>
            </div>
            <div class="remark" v-show="lang === 'en'">
              <span><i class="bg">year</i></span>
              <span><i class="bg month">month</i></span>
              <span><i class="bg day">day</i></span>
            </div>
            <div class="dateA">
              <div class="YearDate">
                <div class="waicen">
                  <div
                    class="shangcen"
                    style="background-color: #127df7;"
                  >{{ $t('overview.monitorContent.ye') }}</div>
                  <div class="xiacen">{{ effect.year.elec }}</div>
                </div>
                <div class="waicen">
                  <div class="shangcen" style="background-color: #127df7;">{{ $t('overview.monitorContent.yc') }}</div>
                  <div class="xiacen">{{ effect.year.co2 }}</div>
                </div>
              </div>
              <div class="MonthDate">
                <div class="waicen">
                  <div
                    class="shangcen"
                    style="background-color: #1da4ec;"
                  >{{ $t('overview.monitorContent.me') }}</div>
                  <div class="xiacen">{{ effect.month.elec }}</div>
                </div>
                <div class="waicen">
                  <div class="shangcen" style="background-color: #1da4ec;">{{ $t('overview.monitorContent.mc') }}</div>
                  <div class="xiacen">{{ effect.month.co2 }}</div>
                </div>
              </div>
              <div class="ToDate">
                <div class="waicen">
                  <div
                    class="shangcen"
                    style="background-color: #65c7fc;"
                  >{{ $t('overview.monitorContent.de') }}</div>
                  <div class="xiacen">{{ effect.day.elec }}</div>
                </div>
                <div class="waicen">
                  <div class="shangcen" style="background-color: #65c7fc;">{{ $t('overview.monitorContent.dc') }}</div>
                  <div class="xiacen">{{ effect.day.co2 }}</div>
                </div>
              </div>
            </div>
          </div>
        </dv-border-box-12>
        <dv-border-box-12 style="height: 25%">
          <div class="chart-inner-bg">
            <div style="position: absolute; top: 0; left: 0;">
              <svg class="svg-inline--fa fa-database icon" style="top: 5%" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="database" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-v-089cdc57="">
                <path class="" fill="currentColor" d="M448 80V128C448 172.2 347.7 208 224 208C100.3 208 0 172.2 0 128V80C0 35.82 100.3 0 224 0C347.7 0 448 35.82 448 80zM393.2 214.7C413.1 207.3 433.1 197.8 448 186.1V288C448 332.2 347.7 368 224 368C100.3 368 0 332.2 0 288V186.1C14.93 197.8 34.02 207.3 54.85 214.7C99.66 230.7 159.5 240 224 240C288.5 240 348.3 230.7 393.2 214.7V214.7zM54.85 374.7C99.66 390.7 159.5 400 224 400C288.5 400 348.3 390.7 393.2 374.7C413.1 367.3 433.1 357.8 448 346.1V432C448 476.2 347.7 512 224 512C100.3 512 0 476.2 0 432V346.1C14.93 357.8 34.02 367.3 54.85 374.7z"></path>
              </svg>
              <span class="title">{{ $t('overview.monitorContent.city') }}</span>
            </div>
            <div style="width: 100%;height:82%;position: absolute;bottom: 0;">
              <div
                style="position: relative; overflow: hidden; width: 100%; height: 100%"
              >
                <div
                  v-if="cityList[0]"
                  class="ball ball1"
                  style=" background-color: #3771f0;
                  width: 1.0156rem;
                  height: 1.0156rem;
                  top: 100%;
                  left: 1%;
                  z-index: 100;"
                >
                  {{ cityList[0] ? cityList[0].key: '' }}<br>
                  {{ cityList[0] ? cityList[0].value: '' }}
                </div>
                <div
                  v-if="cityList[1]"
                  class="ball ball2"
                  style=" background-color: #3d6acc;
                  width: .9218rem;
                  height: .9218rem;
                  top: 100%;
                  left: 2.5rem;
                  z-index: 100;
                  "
                >
                  {{ cityList[1] ? cityList[1].key: '' }}<br>
                  {{ cityList[1] ? cityList[1].value: '' }}
                </div>
                <div
                  v-if="cityList[2]"
                  class="ball ball3"
                  style=" background-color: #2c75d4;
                  width: .8593rem;
                  height: .8593rem;
                  top: 100%;
                  right: 1%;
                  z-index: 99;"
                >
                  {{ cityList[2] ? cityList[2].key: '' }}<br>
                  {{ cityList[2] ? cityList[2].value: '' }}
                </div>
                <div
                  v-if="cityList[3]"
                  class="ball ball4"
                  style=" background-color: #3079d8;
                  width: 0.7812rem;
                  height: 0.7812rem;
                  top: 100%;
                  left: 10%;
                  z-index: 98;"
                >
                  {{ cityList[3] ? cityList[3].key: '' }}<br>
                  {{ cityList[3] ? cityList[3].value: '' }}
                </div>
                <div
                  class="ball ball5"
                  v-if="cityList[4]"
                  style=" background-color: #18d1f1;
                  width: 0.7187rem;
                  height: 0.7187rem;
                  top: 100%;
                  left: 30%;
                  z-index: 97;"
                >
                  {{ cityList[4] ? cityList[4].key: '' }}<br>
                  {{ cityList[4] ? cityList[4].value: '' }}
                </div>
                <div
                  v-if="cityList[5]"
                  class="ball ball6"
                  style=" background-color: #72bfc5;
                  width: 0.7031rem;
                  height: 0.7031rem;
                  top: 100%;
                  left: 42%;
                  z-index: 96;"
                >
                  {{ cityList[5] ? cityList[5].key: '' }}<br>
                  {{ cityList[5] ? cityList[5].value: '' }}
                </div>
                <div
                  v-if="cityList[6]"
                  class="ball ball7"
                  style=" background-color: #19c1df;
                  width: 0.625rem;
                  height: 0.625rem;
                  top: 100%;
                  left: 72%;
                  z-index: 95;"
                >
                  {{ cityList[6] ? cityList[6].key: '' }}<br>
                  {{ cityList[6] ? cityList[6].value: '' }}
                </div>
                <div
                  v-if="cityList[7]"
                  class="ball ball8"
                  style=" background-color: #1bc3e0;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 28%;
                  z-index: 94;"
                >
                  {{ cityList[7] ? cityList[7].key: '' }}<br>
                  {{ cityList[7] ? cityList[7].value: '' }}
                </div>
                <div
                  v-if="cityList[8]"
                  class="ball ball9"
                  style=" background-color: #1bc3e0;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 12%;
                  z-index: 94;"
                >
                  {{ cityList[8] ? cityList[8].key: '' }}<br>
                  {{ cityList[8] ? cityList[8].value: '' }}
                </div>
                <div
                  v-if="cityList[9]"
                  class="ball ball10"
                  style=" background-color: #2ed6ec;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 76%;
                  z-index: 92;"
                >
                  {{ cityList[9] ? cityList[9].key: '' }}<br>
                  {{ cityList[9] ? cityList[9].value: '' }}
                </div>
                <div
                  v-if="cityList[10]"
                  class="ball ball11"
                  style=" background-color: #19d8b8;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 65%;
                  z-index: 91;"
                >
                  {{ cityList[10] ? cityList[10].key: '' }}<br>
                  {{ cityList[10] ? cityList[10].value: '' }}
                </div>
                <div
                  v-if="cityList[11]"
                  class="ball ball12"
                  style=" background-color: #14d8b7;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 47%;
                  z-index: 90;"
                >
                  {{ cityList[11] ? cityList[11].key: '' }}<br>
                  {{ cityList[11] ? cityList[11].value: '' }}
                </div>
                <div
                  v-if="cityList[12]"
                  class="ball ball13"
                  style=" background-color: #15a2f3;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 40%;
                  z-index: 89;"
                >
                  {{ cityList[12] ? cityList[12].key: '' }}<br>
                  {{ cityList[12] ? cityList[12].value: '' }}
                </div>
                <div
                  v-if="cityList[13]"
                  class="ball ball14"
                  style=" background-color: #15a2f3;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 20%;
                  z-index: 88;"
                >
                  {{ cityList[13] ? cityList[13].key: '' }}<br>
                  {{ cityList[13] ? cityList[13].value: '' }}
                </div>
                <div
                  v-if="cityList[14]"
                  class="ball ball15"
                  style=" background-color: #15a2f3;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 15%;
                  z-index: 87;"
                >
                  {{ cityList[14] ? cityList[14].key: '' }}<br>
                  {{ cityList[14] ? cityList[14].value: '' }}
                </div>
                <div
                  v-if="cityList[15]"
                  class="ball ball16"
                  style=" background-color: #3de7f0;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 42%;"
                >
                  {{ cityList[15] ? cityList[15].key: '' }}<br>
                  {{ cityList[15] ? cityList[15].value: '' }}
                </div>
                <div
                  v-if="cityList[16]"
                  class="ball ball17"
                  style=" background-color: #1fd6be;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 91%;"
                >
                  {{ cityList[16] ? cityList[16].key: '' }}<br>
                  {{ cityList[16] ? cityList[16].value: '' }}
                </div>
                <div
                  v-if="cityList[17]"
                  class="ball ball18"
                  style=" background-color: #33d1bc;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 86%;"
                >
                  {{ cityList[17] ? cityList[17].key: '' }}<br>
                  {{ cityList[17] ? cityList[17].value: '' }}
                </div>
                <div
                  v-if="cityList[18]"
                  class="ball ball19"
                  style=" background-color: #33d1bc;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 82%;"
                >
                  {{ cityList[18] ? cityList[18].key: '' }}<br>
                  {{ cityList[18] ? cityList[18].value: '' }}
                </div>
                <div
                  v-if="cityList[19]"
                  class="ball ball20"
                  style=" background-color: #3677cc;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 59%;
                  z-index: 97;"
                >
                  {{ cityList[19] ? cityList[19].key: '' }}<br>
                  {{ cityList[19] ? cityList[19].value: '' }}
                </div>
                <div
                  v-if="cityList[20]"
                  class="ball ball21"
                  style=" background-color: #5cd9e2;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 39%;
                  z-index: 97;"
                >
                  {{ cityList[20] ? cityList[20].key: '' }}<br>
                  {{ cityList[20] ? cityList[20].value: '' }}
                </div>
                <div
                  v-if="cityList[21]"
                  class="ball ball22"
                  style=" background-color: #50e6d9;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 96%;"
                >
                  {{ cityList[21] ? cityList[21].key: '' }}<br>
                  {{ cityList[21] ? cityList[21].value: '' }}
                </div>
                <div
                  v-if="cityList[22]"
                  class="ball ball23"
                  style=" background-color: #4bdace;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 59%;
                  z-index: 97;"
                >
                  {{ cityList[22] ? cityList[22].key: '' }}<br>
                  {{ cityList[22] ? cityList[22].value: '' }}
                </div>
                <div
                  v-if="cityList[23]"
                  class="ball ball24"
                  style=" background-color: #4ac2f1;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 64%;
                  z-index: 97;"
                >
                  {{ cityList[23] ? cityList[23].key: '' }}<br>
                  {{ cityList[23] ? cityList[23].value: '' }}
                </div>
                <div
                  v-if="cityList[24]"
                  class="ball ball25"
                  style=" background-color: #45b3df;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 74%;
                  z-index: 97;"
                >
                  {{ cityList[24] ? cityList[24].key: '' }}<br>
                  {{ cityList[24] ? cityList[24].value: '' }}
                </div>
                <div
                  v-if="cityList[25]"
                  class="ball ball26"
                  style=" background-color: #52b4db;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 90%;
                  z-index: 97;"
                >
                  {{ cityList[25] ? cityList[25].key: '' }}<br>
                  {{ cityList[25] ? cityList[25].value: '' }}
                </div>
                <div
                  v-if="cityList[26]"
                  class="ball ball27"
                  style=" background-color: #4cb3d3;
                  width: 0.5937rem;
                  height: 0.5937rem;
                  top: 100%;
                  left: 60%;"
                >
                  {{ cityList[26] ? cityList[26].key: '' }}<br>
                  {{ cityList[26] ? cityList[26].value: '' }}
                </div>
              </div>
            </div>
          </div>
        </dv-border-box-12>
      </div>
    </div>
    <div class="mask" v-show="isLoading"></div>
  </div>
</template>

<script>
import { getMonitorData, getDetailData } from "@/api/monitor"

const itemColors = ["#96fff6", "#e690d1", "#32c5e9"];
const sortMap = {
  '运行': {
    sort: 0,
    color: "#82fc75",
    zh: '运行',
    en: 'running'
  },
  '待机': {
    sort: 1,
    color: "#037bc2",
    zh: '待机',
    en: 'sleep'
  },
  '备机': {
    sort: 2,
    color: "#f5f552",
    zh: '备机',
    en: 'prepare'
  },
  '未上电': {
    sort: 3,
    color: "#9395a0",
    zh: '未上电',
    en: 'power off'
  }
}

export default {
  data() {
    return {
      totalList: {
        emissionReduction: {}
      },
      dataTypeList: [
        {
          id: 0,
          key: "设备数",
          value: 0,
          n: 'device'
        },
        {
          id: 1,
          key: "代理商",
          value: 0,
          n: 'agent'
        },
        {
          id: 2,
          key: "设备用户",
          value: 0,
          n: 'user'
        }
      ],
      config: {
        data: [
          {
            name: "",
            value: 0
          }
        ],
        showValue: true
      },
      fontSizeOfProgressOption: 18,
      visible: false,
      lowLoad: {
        count: 0
      },
      currentInfo: {
        dataType: 0,
        itemColor: itemColors[0],
        zoom: 5,
        level: 0,
        areaCode: "0",
        lastZoom: 5
      },
      list: [],
      open: 0,
      effect: {
        year: {},
        month: {},
        day: {}
      },
      cityList: [],
      isLoading: true,
      isRouteFullscreen: false
    };
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang(value) {
      if (value === 'en') {
        this.optionOfTrendChart.legend.data = ['Electricity', 'CO₂']
        this.optionOfTrendChart.yAxis[0].name = 'Electricity(kW·h)'
        this.optionOfTrendChart.yAxis[1].name = 'CO₂(t)'
        this.optionOfTrendChart.series[0].name = 'Electricity'
        this.optionOfTrendChart.series[1].name = 'CO₂'
      } else {
        this.optionOfTrendChart.legend.data = ['用电量', '碳减排量']
        this.optionOfTrendChart.yAxis[0].name = '用电量（kW·h）'
        this.optionOfTrendChart.yAxis[1].name = '碳减排量（t）'
        this.optionOfTrendChart.series[0].name = '用电量'
        this.optionOfTrendChart.series[1].name = '碳减排量'
      }
      this.trendChart.setOption(this.optionOfTrendChart);
      this.statusChart.setOption(this.optionOfStatusChart, { replaceMerge: ['legend'] })
    }
  },
  async mounted() {
    const el = this.$refs.container;
    const ratio = 1920 / 1080;
    let isFullScreen = document.fullscreenElement !== null
    this.isRouteFullscreen = this.$route.path.startsWith("/fullscreen")
    this.w = window.innerWidth - 245 < 1200 ? 1200 : window.innerWidth - 245
    this.h = Math.ceil(this.w / ratio)
    if (window.innerWidth < 1500) {
      this.fontSizeOfProgressOption = 15;
    }
    isFullScreen = this.isRouteFullscreen || isFullScreen
    el.style.width = (isFullScreen ? screen.width : this.w) + "px";
    el.style.height = (isFullScreen ? Math.ceil(screen.width / ratio) : this.h) + 'px'
    this.rate = window.innerWidth / 1920
    this.fontSizeOfProgressOption = this.rate * 18
    
    this.flexible();
    try {
      await this.loadScript("https://webapi.amap.com/maps?v=2.0&key=72d96f391e31901608daed111c3535e4")
      await this.loadScript("//webapi.amap.com/ui/1.1/main.js")
      this.scriptLoadedSuccess = true
      this.initMapChart()
    } catch(e) {
      console.log(e)
      this.scriptLoadedSuccess = false
    }
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    this.render();
    this.timer = setInterval(this.render, 600000)
  },
  beforeDestroy() {
    document.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    );
    clearInterval(this.timer);
    this.mapChart && this.mapChart.dispose();
    this.pieChart1 && this.pieChart1.dispose();
    this.pieChart2 && this.pieChart2.dispose();
    this.pieChart3 && this.pieChart3.dispose();
    this.trendChart && this.trendChart.dispose();
  },
  methods: {
    async loadScript(src) {
      return new Promise((resolve, reject) => {
        const existingScript = document.querySelector(`script[src="${src}"]`)
        if (existingScript) {
          resolve()
          return
        }
        const script = document.createElement("script")
        script.type = "text/javascript"
        script.src = src
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
      })
    },
    flexible() {
      const docEl = document.documentElement;
      const dpr = window.devicePixelRatio || 1;
      this.setBodyFontSize(dpr);
      this.setRemUnit(docEl);
    },
    setBodyFontSize(dpr) {
      if (document.body) {
        document.body.style.fontSize = 12 * dpr + "px";
      } else {
        document.addEventListener("DOMContentLoaded", () => {
          this.setBodyFontSize(dpr);
        });
      }
    },
    setRemUnit(docEl, isFullScreen) {
      let rem;
      if (isFullScreen) {
        rem = docEl.clientWidth / 20;
      } else {
        rem = (docEl.clientWidth < 1440 ? 1440 : docEl.clientWidth) / 20;
      }
      docEl.style.fontSize = rem + "px";
    },
    handleFullscreenChange() {
      if (this.resizeTimer) {
        clearTimeout(this.resizeTimer);
      }
      const el = this.$refs.container;
      const isFullScreen = document.fullscreenElement !== null;
      if (isFullScreen) {
        el.style.width = window.innerWidth + "px";
        el.style.height = (window.innerWidth * 1080) / 1920 + "px";
        this.setRemUnit(document.documentElement, true);
      } else {
        el.style.width = this.w + "px";
        el.style.height = this.h + "px";
        this.setRemUnit(document.documentElement);
      }
      this.statusChart && this.statusChart.resize();
      // this.chartOfOnlineDevice && this.chartOfOnlineDevice.resize()
      // this.chartOfLowload && this.chartOfLowload.resize()
      this.mapChart && this.mapChart.resize();
      this.pieChart1 && this.pieChart1.resize();
      this.pieChart2 && this.pieChart2.resize();
      this.pieChart3 && this.pieChart3.resize();
      this.trendChart && this.trendChart.resize();
    },
    async getData(areaCode, dataType) {
      this.isLoading = true;
      try {
        const { data } = await getMonitorData(areaCode, dataType);
        this.totalList = data;
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },
    setData() {
      // const running = {
      //   count: +this.totalList.status.running,
      //   rate: (this.totalList.status.running / (+this.totalList.status.running + +this.totalList.status.shutdown + +this.totalList.status.ready + +this.totalList.status.offline)) * 100
      // }
      // const lowLoad = {
      //   count: +this.totalList.lowLoad,
      //   rate: (this.totalList.lowLoad / (+this.totalList.status.running + +this.totalList.status.shutdown + +this.totalList.status.ready + +this.totalList.status.offline)) * 100
      // }
      // this.running = running
      // this.lowLoad = lowLoad
      this.dataTypeList[0].value = this.totalList.statistic.deviceCnt || 0;
        this.dataTypeList[1].value = this.totalList.statistic.agentCnt  || 0;
        this.dataTypeList[2].value = this.totalList.statistic.customerCnt  || 0;
      if (this.totalList.deviceDistributionTop10) {
        const list = [];
        this.totalList.deviceDistributionTop10.forEach(item => {
          list.push({
            name: item.key,
            value: item.value
          });
        });
        this.config = { ...this.config, data: list };
      }
      const runningStatus = {};
      this.total = 0;
      this.totalList.runningStatus.forEach(r => {
        runningStatus[r.key] = r.value;
        this.total += +r.value;
      });
      this.totalList.runningStatus = runningStatus;
      this.open = (this.totalList.runningStatus["运行"] || 0) + (this.totalList.runningStatus["待机"] || 0);
      this.totalList.emissionReduction.thisYear.forEach(y => {
        this.effect[y.key] = y
      })
      this.cityList = this.totalList.emissionReduction.cities.sort((a, b) => b.value - a.value)
    },
    setMapData() {
      const result = [];
      if (!this.totalList?.list) {
        return result
      }
      this.totalList.list.forEach(({ lng, lat, value, key }) => {
        if (lng && lat) {
          result.push([lng, lat, value, key]);
        }
      });
      return result;
    },
    getMapOption(data, itemColor, center = [108.39, 39.9], zoom = 5) {
      return {
        amap: {
          center: center,
          zoom: zoom,
          resizeEnable: true,
          renderOnMoving: true,
          mapStyle: "amap://styles/darkblue",
          zooms: [4, 25]
        },
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(0,0,0,0.8)",
          borderWidth: 0,
          textStyle: {
            color: "#fff"
          },
          formatter: function(params) {
            return params.data[4];
          }
        },
        animation: true,
        series: [
          {
            type: "effectScatter",
            coordinateSystem: "amap",
            data: data,
            symbolSize: val => {
              const total = val[2];
              if (total < 10) {
                return 20 * this.rate;
              } else if (total < 100 && total >= 10) {
                return 25 * this.rate;
              } else if (total >= 100 && total < 500) {
                return 30 * this.rate;
              } else if (total >= 500 && total < 1000) {
                return 35 * this.rate;
              } else {
                return 40 * this.rate;
              }
            },
            encode: {
              value: 2
            },
            showEffectOn: "render",
            rippleEffect: {
              brushType: "stroke"
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: "{@[2]}",
                position: "inside",
                show: true,
                fontSize: 12 * this.rate
              }
            },
            itemStyle: {
              color: itemColor,
              shadowBlur: 10,
              shadowColor: "#333"
            },
            zlevel: 1
          }
        ]
      };
    },
    getZoom(level) {
      switch (level) {
        case 0:
          return 5;
        case 1:
          return 7;
        case 2:
          return 9;
        default:
          break;
      }
    },
    getCurrentCenter() {
      const option = this.mapChart.getOption();
      const ampOption = option.amap === undefined ? [{ zoom: 5 }] : option.amap;
      return ampOption[0].center;
    },
    initMapChart() {
      const data = this.setMapData();
      const option = this.getMapOption(data, this.currentInfo.itemColor);
      // this.$refs.mapChart.style.scale = this.rate
      if (!this.mapChart) {
        this.mapChart = this.$echarts.init(this.$refs.mapChart);
      }
      this.mapChart.setOption(option);
      this.mapChart.on("click", async params => {
        if (this.isLoading) return;
        const areaCode =
          this.currentInfo.level > 0
            ? this.currentInfo.areaCode + "/" + params.data[3]
            : params.data[3];
        if (this.currentInfo.level <= 2) {
          this.currentInfo.level++;
          if (this.currentInfo.level > 2) {
            this.isLoading = true;
            const { data } = await getMonitorData(
              areaCode,
              this.currentInfo.dataType
            );
            this.totalList = data
            this.isLoading = false;
            const optionData = [];
            data.list.forEach(item => {
              optionData.push([item.lng, item.lat, item.value, item.key]);
            });
            const itemColor = this.currentInfo.itemColor;
            const center = this.getCurrentCenter();
            this.currentInfo.areaCode = areaCode;
            this.currentInfo.zoom++;
            const option = this.getMapOption(
              optionData,
              itemColor,
              center,
              this.currentInfo.zoom
            );
            this.mapChart.setOption(option);
          } else {
            this.isLoading = true;
            await this.getData(areaCode, this.currentInfo.dataType);
            this.isLoading = false;
            const data = this.setMapData();
            const itemColor = this.currentInfo.itemColor;
            const center =
              this.totalList.list === undefined
                ? [108.39, 39.9]
                : [data[0][0], data[0][1]];
            this.currentInfo.zoom = this.getZoom(this.currentInfo.level);
            this.currentInfo.areaCode = areaCode;
            const option = this.getMapOption(
              data,
              itemColor,
              center,
              this.currentInfo.zoom
            );
            this.mapChart.setOption(option);
          }
          this.setData()
          this.initPieChart()
          this.initProgressChart()
          this.initTrendChart()
        }
      });
      this.$refs.mapChart.addEventListener("contextmenu", async () => {
        if (this.isLoading) return;
        if (--this.currentInfo.level < 0) {
          this.currentInfo.level = 0;
        }
        const codeArr = this.currentInfo.areaCode.split("/");
        if (codeArr.length < 2) {
          this.currentInfo.areaCode = "0";
        } else if (this.currentInfo.level < 2) {
          this.currentInfo.areaCode = codeArr[codeArr.length - 2];
        } else {
          this.currentInfo.areaCode = this.currentInfo.areaCode.substring(
            0,
            this.currentInfo.areaCode.lastIndexOf("/")
          );
        }
        await this.getData(
          this.currentInfo.areaCode,
          this.currentInfo.dataType
        );
        const data = this.setMapData();
        const itemColor = this.currentInfo.itemColor;
        const center =
          this.currentInfo.areaCode === "0"
            ? [108.39, 39.9]
            : [this.totalList.list[0].lng, this.totalList.list[0].lat];
        this.currentInfo.zoom = this.getZoom(this.currentInfo.level);
        const option = this.getMapOption(
          data,
          itemColor,
          center,
          this.currentInfo.zoom
        );
        this.mapChart.setOption(option);
        this.setData()
          this.initPieChart()
          this.initProgressChart()
          this.initTrendChart()
      });
    },
    getAmapZoom() {
      const option = this.mapChart.getOption();
      const ampOption = option.amap ? option.amap : [{ zoom: 5 }];
      return ampOption[0].zoom;
    },
    async render(code = 0, type = 0) {
      try {
        await this.getData(code, type)
        this.setData();
        this.initPieChart();
        this.initProgressChart();
        if (this.scriptLoadedSuccess) {
          this.initMapChart();
        }
        this.initTrendChart();
      } catch(e) {
        console.log(e)
      }
    },
    async changeDataType(areaCode, dataType) {
      this.currentInfo.dataType = dataType;
      this.currentInfo.itemColor = itemColors[dataType];
      this.currentInfo.level = 0;
      this.currentInfo.zoom = 5;
      this.currentInfo.areaCode = "0";
      this.render(areaCode, dataType)
    },
    getProgressOption(text, value, shadowColor, color, itemColor, dataValue) {
      return {
        series: [
          {
            type: "pie",
            radius: ["82%", "86%"],
            center: ["50%", "57%"],
            color,
            label: {
              show: true,
              position: "center",
              fontSize: this.fontSizeOfProgressOption,
              fontWeight: "bold",
              color: "#fff",
              formatter: () => {
                return text;
              }
            },
            data: [
              {
                value,
                itemStyle: {
                  show: false,
                  color: itemColor,
                  shadowBlur: 10,
                  shadowColor: shadowColor
                }
              },
              dataValue
            ]
          }
        ]
      };
    },
    initPieChart() {
      const data = [];
      for (let k in this.totalList.runningStatus) {
        data.push({
          name: k,
          value: this.totalList.runningStatus[k]
        });
      }
      console.log(this.totalList.runningStatus)
      data.sort((a, b) => sortMap[a.name].sort - sortMap[b.name].sort)
      this.optionOfStatusChart = {
        tooltip: {
          trigger: "item",
          backgroundColor: "rgba(255, 255, 255, .1)",
          borderWidth: 0,
          textStyle: {
            color: "#d3d6dd"
          }
        },
        legend: {
          type: "scroll",
          orient: "vertical",
          right: 5,
          top: "center",
          textStyle: {
            color: "#d3d6dd",
            fontSize: 20 * this.rate
          },
          itemHeight: 20 * this.rate,
          itemWidth: 25 * this.rate,
          formatter: name =>
            `${sortMap[name][this.lang]} ${Number(this.totalList.runningStatus[name])}`,
          show: true
        },
        label: {
          formatter: "{d}%",
          color: "#d3d6dd"
        },
        series: [
          {
            type: "pie",
            radius: ["50%", "70%"],
            center: ["30%", "55%"],
            itemStyle: {
              borderRadius: 0
            },
            data,
            // color: ['#037bc2', '#82fc75', '#f5f552', '#9395a0'],
            // color: ["#f5f552", "#9395a0", "#037bc2", "#82fc75"],
            color: data.map(d => sortMap[d.name].color),
            label: {
              show: true,
              position: "center",
              fontSize: 20 * this.rate,
              fontWeight: "bold",
              formatter: () => {
                return (
                  Object.values(this.totalList.runningStatus).reduce(
                    (a, b) => a + b,
                    0
                  ) + "\n台"
                );
              }
            }
          }
        ]
      };
      if (!this.statusChart) {
        this.statusChart = this.$echarts.init(
          document.querySelector(".statusChart")
        );
      }
      this.statusChart.setOption(this.optionOfStatusChart);
    },
    initProgressChart() {
      const dom1 = this.$refs.chart1;
      const dom2 = this.$refs.chart2;
      const dom3 = this.$refs.chart3;
      if (!this.pieChart1) {
        this.pieChart1 = this.$echarts.init(dom1);
      }
      if (!this.pieChart2) {
        this.pieChart2 = this.$echarts.init(dom2);
      }
      if (!this.pieChart3) {
        this.pieChart3 = this.$echarts.init(dom3);
      }
      this.option1 = {
        title: {
          text: `${((this.total ? (this.open / this.total) : 0) * 100).toFixed(2)}%`,
          textStyle: {
            color: "#fff",
            fontWeight: "normal",
            fontSize: this.rate * 18
          },
          top: "center",
          left: "center"
        },
        series: [
          {
            type: "pie",
            radius: ["80%", "90%"],
            center: ["50%", "50%"],
            color: ["#00bcd44a", "transparent"],
            label: {
              show: false
            },
            data: [
              {
                value: (this.open / this.total) * 100,
                itemStyle: {
                  color: "#03a9f4",
                  shadowBlur: 10,
                  shadowColor: "#97e2f5"
                }
              },
              {
                value: 100 - (this.open / this.total) * 100
              }
            ]
          }
        ]
      };
      this.option2 = {
        title: {
          text: `${(this.totalList.deviceAnalysis.avgLoadRate * 100).toFixed(
            2
          )}%`,
          textStyle: {
            color: "#fff",
            fontWeight: "normal",
            fontSize: this.rate * 18
          },
          top: "center",
          left: "center"
        },
        series: [
          {
            type: "pie",
            radius: ["92%", "98%"],
            center: ["50%", "50%"],
            color: ["#faf3a378", "transparent"],
            label: {
              show: false
            },
            data: [
              {
                value: this.totalList.deviceAnalysis.avgLoadRate * 100,
                itemStyle: {
                  color: "#ff9800",
                  shadowBlur: 10,
                  shadowColor: "#fcebad"
                }
              },
              {
                value: 100 - this.totalList.deviceAnalysis.avgLoadRate
              }
            ]
          }
        ]
      };
      this.option3 = {
        series: [
          {
            type: "gauge",
            center: ["50%", "60%"],
            startAngle: 200,
            endAngle: -20,
            min: 75,
            max: 100,
            radius: "100%",
            splitNumber: 5,
            itemStyle: {
              color: "#e95742"
            },
            pointer: {
              width: 3,
              length: "68%",
              itemStyle: {
                color: "inherit"
              }
            },
            axisLine: {
              lineStyle: {
                width: 8,
                color: [
                  [10 / 25, "#82fc75"],
                  [15 / 25, "#f5f552"],
                  [1, "#fd666d"]
                ]
              }
            },
            axisTick: {
              distance: -15,
              splitNumber: 4,
              lineStyle: {
                width: 2,
                color: "#999"
              },
              show: false
            },
            splitLine: {
              distance: -20 * this.rate,
              length: 0,
              lineStyle: {
                width: 3,
                color: "#999"
              },
              show: false
            },
            axisLabel: {
              distance: 8,
              color: "#f8f8f8",
              fontSize: 10 * this.rate,
            },
            anchor: {
              show: false
            },
            title: {
              show: false,
              textStyle: {
                fontSize: this.rate * 18
              }
            },
            detail: {
              valueAnimation: true,
              width: "60%",
              lineHeight: 5,
              borderRadius: 8,
              offsetCenter: ["7%", "30%"],
              fontSize: 20 * this.rate,
              fontWeight: "bolder",
              formatter: "{value} ",
              color: "inherit"
            },
            data: [
              {
                value: this.totalList.deviceAnalysis.avgTemperature
              }
            ]
          }
        ]
      };

      this.pieChart1 && this.pieChart1.setOption(this.option1);
      this.pieChart2 && this.pieChart2.setOption(this.option2);
      this.pieChart3 && this.pieChart3.setOption(this.option3);
      // runningCount.value = running.count
      // lowLoadCount.value = lowLoad.count
    },
    initTrendChart() {
      this.optionOfTrendChart = {
        title: {
          textStyle: {
            color: "#fff",
            fontWeight: "normal"
          },
          top: "center",
          left: "center"
        },
        grid: {
          top: '33%',
          left: "13%",
          right: "13%",
          bottom: "10%",
          // containLabel: true
        },
        legend: {
          data: ["用电量", "碳减排量"],
          textStyle: {
            color: "white",
            fontSize: this.rate * 16
          },
          right: 0
        },
        xAxis: {
          type: "category",
          data: this.totalList.emissionReduction.erTrend.map(y => y.key),
          axisLine: {
            show: true,
            lineStyle: {
              color: "white"
            }
          },
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            fontSize: this.rate * 12
          }
        },
        yAxis: [
          {
            name: "用电量（kW·h）",
            nameTextStyle : {
              fontSize: this.rate * 12,
            },
            type: "value",
            axisLine: {
              show: true,
              lineStyle: {
                color: "white"
              }
            },
            axisLabel: {
              formatter: "{value} 亿",
              fontSize: this.rate * 12
            }
          },
          {
            type: "value",
            name: "碳减排量（t）",
            nameTextStyle : {
              fontSize: this.rate * 12,
            },
            position: "right",
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: "skyblue"
              }
            },
            axisLabel: {
              formatter: "{value} 万",
              fontSize: this.rate * 12
            }
          }
        ],

        series: [
          {
            name: "用电量",
            type: "bar",
            barWidth: "30%",
            data: this.totalList.emissionReduction.erTrend.map(y => y.elec)
          },
          {
            name: "碳减排量",
            type: "bar",
            barWidth: "30%",
            yAxisIndex: 1,
            data: this.totalList.emissionReduction.erTrend.map(y => y.co2)
          }
        ]
      };
      if (!this.trendChart) {
        this.trendChart = this.$echarts.init(
          document.querySelector(".trendChart")
        );
      }
      if (this.lang === 'en') {
        this.optionOfTrendChart.legend.data = ['Electricity', 'CO₂']
        this.optionOfTrendChart.yAxis[0].name = 'Electricity(kW·h)'
        this.optionOfTrendChart.yAxis[1].name = 'CO₂(t)'
        this.optionOfTrendChart.series[0].name = 'Electricity'
        this.optionOfTrendChart.series[1].name = 'CO₂'
      } else {
        this.optionOfTrendChart.legend.data = ['用电量', '碳减排量']
        this.optionOfTrendChart.yAxis[0].name = '用电量（kW·h）'
        this.optionOfTrendChart.yAxis[1].name = '碳减排量（t）'
        this.optionOfTrendChart.series[0].name = '用电量'
        this.optionOfTrendChart.series[1].name = '碳减排量'
      }
      this.trendChart.setOption(this.optionOfTrendChart);
    }
  }
};
</script>

<style lang="less" scoped>
.fullscreen {
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  &::-webkit-scrollbar {
    width: 0;
  }
}
// *:not(h1.title) {
//   font-weight: normal !important;
// }
#map {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: #000001;
}
.container {
  position: relative;
  overflow: hidden;
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 99;
  display: flex;
  justify-content: center;
  align-items: center;
}
.list-dialog {
  width: 60%;
  // margin: 30rem auto;
  padding: 0.3125rem;
  border-radius: 0.5208rem;
  background-color: rgb(19, 25, 47);
  color: #fff;
  //background-color: #222;
  //box-shadow: 0 8px 100px -4px rgb(0 0 0 / 50%);
  box-shadow: 0 8px 20px -4px rgba(0, 0, 0, 0.49);
  .list-dialog-inner {
    width: 100%;
    max-height: 6.25rem;
    padding-right: 0.625rem;
    padding-left: 0.5208rem;
    overflow-y: auto;
    box-sizing: border-box;
    &::-webkit-scrollbar {
      /*滚动条整体样式*/
      width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
      height: 4px;
    }
    &::-webkit-scrollbar-thumb {
      /*滚动条滑块*/
      border-radius: 5px;
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      background: rgba(150, 255, 246, 0.9);
    }
    &::-webkit-scrollbar-track {
      /*滚动条轨道*/
      box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: rgba(0, 0, 0, 0.1);
    }
  }
}
.header {
  width: 100%;
  height: 20%;
  position: absolute;
  top: 1%;

  .header-inner {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;

    .title {
      text-align: center;
      font-size: .2917rem;
      color: #fff;
      font-weight: 600;
      margin: .1042rem 0;
      line-height: .2083rem;
    }
  }
}

.toggleNav {
  position: absolute;
  top: 12%;
  left: 50%;
  width: 34%;
  height: 10%;
  transform: translateX(-50%);
  display: flex;
  justify-content: space-between;

  .item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: .25rem;
    color: #fff;
    width: 28%;
    height: 100%;
    border-radius: 15%;
    text-align: center;
    background-color: rgba(19, 25, 47, 0.75);
    padding: 1% 1%;
    cursor: pointer;
  }
}

.col {
  width: 26%;
  height: 93%;
  position: absolute;
  top: 5%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;

  .dv-border-box-12 {
    padding: 2.6%;
    position: relative;

    svg {
      width: 0.3125rem;
      height: 0.3125rem;
      margin: 1%;
      color: #5cd9e8;
    }

    .title {
      position: absolute;
      color: #fff;
      left: 0.4167rem;
      white-space: nowrap;
      top: 0.1563rem;
      transform: translateY(-50%);
      font-size: 0.1667rem;
    }
  }
}

.flex {
  width: 100%;
  display: flex;
  justify-content: center;

  .analysis {
    text-align: center;
    font-size: 0.1771rem;
    margin: 0;
    color: #fff;
  }
}

.chart-inner-bg {
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.flex_column {
  display: flex;
  flex-direction: column;
  align-items: center;
  div {
    text-align: center;
  }
}

[class^="icon"] {
  width: 0.729rem;
  height: 0.729rem;
  margin: 0.208rem auto 0;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  &.icon-kwc {
    background-image: url(../../../assets/kwc.png);
  }
  &.icon-kwh {
    background-image: url(../../../assets/kwh.png);
  }
  &.icon-avg-load {
    background-image: url(../../../assets/avgLoad.png);
  }
  &.icon-avg-temp {
    background-image: url(../../../assets/avgTemp.png);
  }
  &.icon-warning {
    background-image: url(../../../assets/warning.png);
  }
  &.icon-date {
    background-image: url(../../../assets/date.png);
  }
}

h2.data {
  color: #fff;
  font-size: .2292rem;
  font-weight: normal;
}

h3.description {
  color: #fff;
  font-size: .1875rem;
  font-weight: normal;
  text-align: center;
}

.maintenance {
  width: 100%;
  height: 100%;
  padding: 10% 2%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  * {
    color: #fff;
    font-size: 0.208rem;
  }
  & > div {
    display: flex;
    justify-content: space-around;
  }
  .maintenance-status {
    width: 100%;
    height: 10px;
    border-radius: 5px;
    background: linear-gradient(90deg, #e7453f, #fff35c);
  }
}
@media screen and (max-width: 1500px) {
  .w {
    overflow-x: auto;
  }
  .dv-decoration-10 {
    width: 28% !important;
  }
  .title_wrapper {
    width: 20% !important;
  }
  :-webkit-full-screen {
    .w {
      overflow-x: hidden;
    }
    .dv-decoration-10 {
      width: 30% !important;
    }
    .title_wrapper {
      width: 16% !important;
    }
  }
}
@media screen and (max-width: 1024px) {
  :-webkit-full-screen {
    .col {
      .capsule_wrapper {
        padding-right: 0 !important;
        height: unset !important;
        transform: scaleY(0.96) !important;
        .dv-capsule-chart {
          width: 90% !important;
          height: unset !important;
        }
      }
    }
  }
}
@media screen and (max-width: 900px) {
  :-webkit-full-screen {
    .col {
      width: 30%;
      br {
        display: none;
      }
      .capsule_wrapper {
        padding-right: 0 !important;
        height: unset !important;
        transform: scaleY(0.76) !important;
        .dv-capsule-chart {
          width: 90% !important;
          height: unset !important;
        }
      }
    }
  }
}
/deep/ .dv-capsule-chart .capsule-item {
  height: 20px;
}
/deep/ .dv-capsule-chart .capsule-item .capsule-item-column {
  height: 18px;
}
/deep/ .label-column {
  font-size: 21px;
}
/deep/
  .dv-capsule-chart
  .capsule-item
  .capsule-item-column
  .capsule-item-value {
  font-size: 16px;
}
/deep/ .dv-capsule-chart .label-column div {
  line-height: 28px;
}
.dateA {
  width: 100%;
  height: 100%;
  justify-content: center;
  display: flex;
  color: #fff;

  .waicen {
    width: 98%;
    height: 49%;
    border: 2px #37a2da dashed;
    margin: 2px;
    font-size: .2188rem;

    .shangcen {
      width: 98%;
      height: 49%;
      margin: 2px;
      background-color: #37a2da;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: .1567rem;
    }

    .xiacen {
      width: 100%;
      height: 49%;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: .1775rem;
    }
  }

  .YearDate {
    width: 33%;
    height: 100%;
    padding: 8% 0 1%;
    // margin-left: 10%;
    // border-right: 1px #37a2da solid;
  }

  .MonthDate {
    width: 33%;
    height: 100%;
    padding: 8% 0 1%;
  }

  .ToDate {
    width: 33%;
    height: 100%;
    padding: 8% 0 1%;
    // border-left: 1px #37a2da solid;
  }
}
.ball {
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  position: absolute;
  color: #fff;
  font-size: .1458rem;
}

.ball1 {
  animation: move 12s infinite linear 0s;
}

.ball2 {
  animation: move 11.7s infinite linear 3s;
}
.ball3 {
  animation: move 11s infinite linear 7s;
}

.ball4 {
  animation: move 10s infinite linear 10s;
}

.ball5 {
  animation: move 10.1s infinite linear 6s;
}

.ball6 {
  animation: move 10s infinite linear 3s;
}

.ball7 {
  animation: move 9s infinite linear 0s;
}

.ball8 {
  animation: move 7.8s infinite linear 8.5s;
}

.ball9 {
  animation: move 8.6s infinite linear 1.7s;
}

.ball10 {
  animation: move 8s infinite linear 5.5s;
}
.ball11 {
  animation: move 8.9s infinite linear 3s;
}
.ball12 {
  animation: move 8.1s infinite linear 5.7s;
}
.ball13 {
  animation: move 8.6s infinite linear 9.2s;
}
.ball14 {
  animation: move 8.9s infinite linear 8.9s;
}
.ball15 {
  animation: move 6.6s infinite linear 8s;
}
.ball16 {
  animation: move 7.5s infinite linear 7s;
}
.ball17 {
  animation: move 6.5s infinite linear 4s;
}
.ball18 {
  animation: move 9.5s infinite linear 5.5s;
}
.ball19{
  animation: move 7.7s infinite linear 9.1s;
}
.ball20 {
  animation: move 9.5s infinite linear 10s;
}
.ball21 {
  animation: move 8.5s infinite linear 6.5s;
}
.ball22 {
  animation: move 7s infinite linear 3.5s;
}
.ball23 {
  animation: move 7s infinite linear 6.5s;
}
.ball24 {
  animation: move 7.5s infinite linear 4.9s;
}
.ball25 {
  animation: move 8s infinite linear 6s;
}
.ball26 {
  animation: move 9.5s infinite linear 9s;
}
.ball27 {
  animation: move 8.1s infinite linear 7s;
}


@keyframes move {
  0% {
    top: 100%;
  }

  100% {
    top: -1rem;
  }
}
.mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: wait;
  // z-index: 1000;
  opacity: 0;
}
/deep/ .dv-capsule-chart .capsule-item .capsule-item-column .capsule-item-value {
  font-size: .1667rem;
}
.remark {
  position: absolute;
  top: 1%;
  right: 1%;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
  vertical-align: middle;
  span:nth-child(2) {
    margin: 0 10px;
  }
  .bg {
    display: inline-block;
    width: .4688rem;
    height: .2083rem;
    background-color: #127df7;
    line-height: .2083rem;
    &.month {
      background-color: #1da4ec;
    }
    &.day {
      background-color: #65c7fc;
    }
  }
}
.svgs {
  cursor: pointer;
  path {
    fill: transparent;
  }
  &:hover {
    path {
      fill: #fff;
    }
  }
}

:-webkit-full-screen {
  .dateA {
    .waicen {
      .shangcen {
        font-size: .1667rem;
      }
      .xiacen {
        font-size: .1875rem;
      }
    }
  }
}
</style>
